<template>
  <ul class="columns is-variable is-1">
    <ChartSelectorPanel
      v-for="chartContent in activeChartsDefinition"
      :key="chartContent.name"
      :chartContent="chartContent"
      :chartData="activePerformanceData[chartContent.name]"
      :activeChartContentName="activeChartContentName"
      class="column is-one-quarter"
      @setActiveChartContentName="$emit('setActiveChartContentName', chartContent.name)"
    />
  </ul>
</template>

<script>
import { PERFORMANCE_DEFINITION } from "@/misc/desktopCharts";
import ChartSelectorPanel from "./ChartSelectorPanel";

export default {
  components: {
    ChartSelectorPanel,
  },
  props: {
    activeViewName: {
      type: String,
      required: true,
    },
    activeChartContentName: {
      type: String,
      required: true,
    },
    activePerformanceData: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    activeChartsDefinition() {
      const activeViewName = this.activeViewName;
      return PERFORMANCE_DEFINITION.find((view) => view.name === activeViewName).content;
    },
  },
};
</script>
